<template>
  <div>
    <div v-for="(item,key) in goodsList" :key="key">
		{{item}}
	</div>
  </div>
</template>

<script>
import { getRefundGoods } from "@api/order";
export default {
  name: "BatchRefund",
  data: function() {
    return {
		goodsList: []
    };
  },
  watch: {
    $route(n) {
	  if(n.name == 'BatchRefund'){
		this.getRefundGoods();
	  }
    }
  },
  mounted: function() {
    this.getRefundGoods();
  },
  methods: {
	getRefundGoods(){
		let that = this;
		let unique = that.$route.params.id;
		getRefundGoods(unique).then(res => {
			that.goodsList = res.data.cartInfo;
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
  }
};
</script>
<style scoped>

</style>